// src/utils/getSchemaForAction.js

/**
 * resolveActionGroup — which top-level caption group an action owns.
 *
 * "TEAM_1_SCORE_UPDATE" → "Main", "SPONSOR_IN" → "Sponsor", "CARD_OUT" →
 * "Cards"; null for the actions that carry no data of their own (bare IN /
 * OUT / PREVIEW / RESET), which is also how the full-graphic take is
 * recognised.
 *
 * Exported because the group IS the authority on what an action may write:
 * callers must not keep their own list of action names — see the overlay
 * score guard in TXLive (OPUS-1302).
 */
export function resolveActionGroup(act) {
  // Main-level stuff
  if (act === "TEAM_1_SCORE_UPDATE") return "Main";
  if (act === "TEAM_2_SCORE_UPDATE") return "Main";
  if (act === "TEAM_NAMES_IN") return "Main";

  // Sectional stuff
  if (act.startsWith("ADDITIONAL_TIME_")) return "AdditionalTime";
  if (act.startsWith("ATTACKING_THREAT_")) return "AttackingThreat";
  if (act.startsWith("CARD_")) return "Cards";
  if (act.startsWith("GOALSCORER_")) return "GoalScorer";
  if (act.startsWith("MATCH_STATS_")) return "MatchStats";
  if (act.startsWith("FREE_TEXT_")) return "FreeText";
  if (act.startsWith("SPONSOR_")) return "Sponsor";
  if (act.startsWith("SUBSTITUTION_")) return "Substitution";
  if (act.startsWith("WIN_PROBABILITY_")) return "WinProbability";

  // PREVIEW / RESET / IN / OUT (no extra data) → null
  return null;
}

export default function getSchemaForAction(schema, action) {
  if (!action) return null;

  const group = resolveActionGroup(action);

  // If this action doesn't have a data payload → no form
  if (!group) {
    console.warn("[getSchemaForAction] No schema group for action:", action);
    return null;
  }

  const groupSchema = schema.properties[group];

  // Safety guard: if schema doesn't define that section
  if (!groupSchema) {
    console.warn(
      "[getSchemaForAction] Schema has no properties['" + group + "'] for action:",
      action
    );
    return null;
  }

  // Final mini-schema for RJSF
  return {
    type: "object",
    properties: {
      action: { const: action },
      [group]: groupSchema
    },
    required: [group]
  };
}